import { ITreeStructure } from '../models/treeStructure'

export const getOriginalData = <T>(flatData: ITreeStructure[]): T[] => {
  return flatData.map<T>((it) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { checkedState, hasChildren, nestedItems, parent, title, ...dataShape } = it

    return dataShape as T
  })
}
